<template>
  <div>
    <measure-modal
        :field-names="fieldNames"
        :measure_to_edit="measure_to_edit"
        @reset="resetMeasureToEdit"
      >
        <button ref="measure_modal" slot="activator" class="mb-2 ui blue button">
          <i class="add icon"></i>{{ $t('Add a new measure') }}
        </button>
    </measure-modal>

    <div
      v-if="customer.measures.length > 0"
      class="measure-list"
      :key="'measure_list_' + customer.id"
    >
      <datatable
        ref="m_table"
        :column_widths="column_widths"
        :columns="measure_fields"
        :fetch="fetchData"
        :editable="true"
        :deletable="true"
        :duplicatable="true"
        class="ui celled table left aligned fixed collapsing striped"
        @delete_clicked="askDeleteMeasure"
        @edit_clicked="editMeasure"
        @duplicate_clicked="duplicateMeasure"
      >
      </datatable>
    </div>
    <popup-modal
      :index="measure_to_delete"
      icon="delete"
      cancel_class="ui red basic cancel inverted button"
      confirm_class="ui green ok inverted button"
      text="Are you sure you want to delete this measure ?"
      @cancel="measure_to_delete = null"
      @delete="deleteMeasure"
    ></popup-modal>
  </div>
</template>

<script>
import axios from 'axios'
import MeasureModal from '../../components/Modal/MeasureModal'

export default {
  name: 'MeasurementTab',
  components: {
    MeasureModal
  },
  props: {
    customer: {
      type: Object,
      default: () => ({})
    },

  },
  data() {
    return {
      measure_to_edit: null,
      measure_to_delete: null,
      measure_fields: [],
      fieldNames: {},
      column_widths: [150, 80],
    }
  },
  mounted() {
    this.refreshCustomerMeasures()
  },
  methods: {
    refresh() {
      this.refreshCustomerMeasures().then(() => {
        this.$refs.m_table.fetchData()
      })
    },
    refreshMeasureFields() {
      return axios.get('/measure/fields').then((response) => {
        this.measure_fields = response.data.measure_fields
        this.measure_fields.forEach((el) => {
          this.$set(this.fieldNames, el.id, el.name)
        })
      })
    },
    fetchData(callback) {
      callback(this.customer.measures)
    },
    refreshCustomerMeasures() {
      return this.refreshMeasureFields()
      .then(() => axios
          .get(`/customer/${this.customer.id}/measures`)
          .then((response) => {
          this.$store.dispatch(
            'setCurrentCustomerMeasures',
            response.data.measures
            )
          }))
    },
    askDeleteMeasure(measure) {
      this.measure_to_delete = measure
    },
    editMeasure(measure) {
      this.measure_to_edit = measure
      this.$store.dispatch('setCurrentMeasure', measure)
      this.$refs.measure_modal.click()
    },
    resetMeasureToEdit() {
      this.measure_to_edit = null
      this.refresh()
    },
    deleteMeasure() {
      axios
        .delete(`/measures/${this.measure_to_delete.id}`)
        .then((response) => {
          this.$store.dispatch('deleteMeasure', response.data.measures)
          this.measure_to_delete = null
          this.refresh()
        })
    },
    duplicateMeasure(measure) {
      axios.post(`/measures/${measure.id}/duplicate`).then((response) => {
        this.$store.dispatch('duplicateMeasure', response.data.measures)
        this.refresh()
      })
    },
    saveMeasures() {
      // todo
    },
  }
}
</script>

<style scoped>
.measure-list {
  overflow-x: auto;
}
</style>


// WEBPACK FOOTER //
// MeasurementTab.vue?32986c70